import { FC } from "react";

import SitesVisual from "../../../../assets/images/content/pillar-2/applia-members-manufacturing-sites-in-europe/applia-members-manufacturing-sites-in-europe.svg";

const MembersManufacturingSites: FC = () => {
	return (
<div className="flex flex-col md:flex-row items-center content-center justify-center">
  <img
    className="block w-full md:w-1/3 max-w-md self-start"
    src={SitesVisual}
  />
  <div className="w-full md:w-2/3" style={{ position: 'relative', height: '650px' }}>
    <iframe
      title="My Chart"
      aria-label="chart"
      src="https://datawrapper.dwcdn.net/zpFmg/1/"
      scrolling="no"
      frameBorder="0"
      style={{ width: '100%', border: 'none', height: '650px' }}
    />
  </div>
</div>
  );
};

export { MembersManufacturingSites };

